var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInlineSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 7V3.5",
    stroke: "#5557C9",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.9585 9.04154L21.4668 6.5332",
    stroke: "#5557C9",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.2,
    d: "M21 14H24.5",
    stroke: "#5557C9",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M18.9585 18.959L21.4668 21.4673",
    stroke: "#5557C9",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.6,
    d: "M14 21V24.5",
    stroke: "#5557C9",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.8,
    d: "M9.04154 18.959L6.5332 21.4673",
    stroke: "#5557C9",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.9,
    d: "M7 14H3.5",
    stroke: "#5557C9",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.04154 9.04154L6.5332 6.5332",
    stroke: "#5557C9",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInlineSpinner);
export default __webpack_public_path__ + "static/media/inline-spinner.04ae59a1e333a3523a797ab307ff2465.svg";
export { ForwardRef as ReactComponent };